import {useCallback, useEffect, useMemo} from 'react';
import {Configs} from '../configs';
import {useDispatch, useSelector} from 'react-redux';
import {setSelectedBackgroundAction} from '../store/ui/actions';
import {useFilterSelector} from './filter-selector';
import {useOrientation} from './orientation';
import {MediaFileTag} from '../store/ui/state';

class BackgroundService {
    private setValue: (value: string) => void;

    constructor(setValue: (value: string) => void) {
        this.setValue = setValue;
    }

    public changeBackground(value: string): void {
        this.setValue(value);
    }
}

export function useBackground(): [string, (value: string) => void, { backgroundImage: string }] {
    const value = useSelector(state => state.ui.selectedBackground);
    const orientation = useOrientation('horizontal');
    const backgrounds = useFilterSelector(state => state.ui.mediaFileList, i => i.type === 'background' && i.tags.includes(orientation as MediaFileTag), [orientation]);

    const dispatch = useDispatch();
    const setValue = useCallback((newValue: string) => dispatch(setSelectedBackgroundAction(newValue)), [dispatch]);

    useEffect(() => {
        if (!window.services) {
            window.services = new Map();
        }
        
        const backgroundService = new BackgroundService(setValue);
        window.services.set('background', backgroundService);

        return () => {
            window.services.delete('background');
        };
    }, [setValue]);

    useEffect(() => {
        if (value) {
            return;
        }
        const checkMediaLink = async () => {
            const response = await fetch(`${Configs.IMAGE_PREFIX}media/${value}`, {
                mode: "no-cors"
            })
            if (!response.ok) {
                setValue(backgrounds[5]?.id)
                return
            }
            const selected = backgrounds[Math.floor(Math.random() * backgrounds.length)]
            if (selected) {
                setValue(selected.id)
            }
        }
        checkMediaLink()
    }, [value, backgrounds, setValue]);

    const style = useMemo(() => {
        return {
            backgroundImage: `url(${Configs.IMAGE_PREFIX}/media/${value})`,
        };
    }, [value]);

    return [value, setValue, style];
}
